export type GameStatus = 'playing' | 'won' | 'lost';

export type LetterState = 'unused' | 'correct' | 'wrong' | 'selected';

export type Difficulty = 'easy' | 'medium' | 'hard';

export interface GameState {
  word: string;
  guessedLetters: Set<string>;
  wrongGuesses: number;
  maxWrongGuesses: number;
  status: GameStatus;
  difficulty: Difficulty;
  score: number;
  gamesPlayed: number;
  gamesWon: number;
}

export interface WordCategory {
  name: string;
  words: string[];
}

export const WORD_CATEGORIES: WordCategory[] = [
  {
    name: 'Animals',
    words: [
      'elephant', 'giraffe', 'penguin', 'dolphin', 'octopus',
      'butterfly', 'chameleon', 'flamingo', 'hedgehog', 'kangaroo',
      'leopard', 'mongoose', 'panther', 'raccoon', 'squirrel',
      'tortoise', 'walrus', 'cheetah', 'jaguar', 'koala',
    ],
  },
  {
    name: 'Countries',
    words: [
      'canada', 'brazil', 'japan', 'egypt', 'sweden',
      'thailand', 'portugal', 'ireland', 'iceland', 'morocco',
      'austria', 'belgium', 'denmark', 'finland', 'poland',
      'hungary', 'romania', 'croatia', 'slovenia', 'greece',
    ],
  },
  {
    name: 'Movies',
    words: [
      'inception', 'avatar', 'gladiator', 'titanic', 'jaws',
      'rocky', 'casablanca', 'psycho', 'vertigo', 'braveheart',
      'scarface', 'goodfellas', 'apocalypse', 'outbreak', 'twister',
      'scream', 'frozen', 'moana', 'coco', 'up',
    ],
  },
  {
    name: 'Food',
    words: [
      'spaghetti', 'lasagna', 'burrito', 'croissant', 'pancake',
      'cupcake', 'doughnut', 'muffin', 'baguette', 'fajita',
      'tortilla', 'quesadilla', 'goulash', 'paella', 'sashimi',
      'wasabi', 'kimchi', 'ramen', 'pho', 'curry',
    ],
  },
  {
    name: 'Science',
    words: [
      'astronomy', 'biology', 'chemistry', 'physics', 'geometry',
      'algebra', 'calculus', 'genetics', 'ecology', 'geology',
      'meteor', 'comet', 'nebula', 'galaxy', 'plasma',
      'proton', 'neutron', 'electron', 'quantum', 'crystal',
    ],
  },
];

export const DIFFICULTY_SETTINGS: Record<Difficulty, { maxWrong: number; label: string }> = {
  easy: { maxWrong: 8, label: 'Easy' },
  medium: { maxWrong: 6, label: 'Medium' },
  hard: { maxWrong: 4, label: 'Hard' },
};

export const ALPHABET = 'abcdefghijklmnopqrstuvwxyz'.split('');

export function getRandomWord(category?: string): string {
  const categories = category
    ? WORD_CATEGORIES.filter((c) => c.name === category)
    : WORD_CATEGORIES;
  if (categories.length === 0) return 'hangman';
  const cat = categories[Math.floor(Math.random() * categories.length)];
  return cat.words[Math.floor(Math.random() * cat.words.length)];
}
